module.exports = __webpack_public_path__ + "img/woocommerce_blanco.9c6a68da.png";